export enum InstalmentType {
    ANNUAL = 'Annual',
    INSTALMENTS_2 = '2 Instalments',
    INSTALMENTS_3 = '3 Instalments',
    INSTALMENTS_4 = '4 Instalments',
    INSTALMENTS_10 = '10 Instalments',
    INSTALMENTS_12 = '12 Instalments',
    MONTHLY = 'Monthly',
    BESPOKE = 'Bespoke',
}
